<template>
  <div>
    <div v-if="jobID">
      <iframe
        ref="iframe"
        :src="url"
        width="100%"
        @load="adjustIframe"
        frameborder="0"
        height="2000px"
      ></iframe>
    </div>
    </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "SSResult",
  components: {  },
  data() {
    return {
      jobID: "",
      url: "http://119.45.200.53:14567/",
      timer: "",
      iframeHeight: 0,
    };
  },
  created() {
    this.$store.commit("CHANGESSRESULT");
    this.loadInfo();
  },
  beforeDestroy() {
    this.$store.commit("CHANGESSRESULT");
    window.removeEventListener("message", this.iframeHeightBypostmessage);
  },
  mounted() {
    window.addEventListener("message", this.iframeHeightBypostmessage);
  },
  methods: {
    loadInfo() {
      this.jobID = sessionStorage.getItem("jobID");
      console.log(this.jobID, "jobID in SSResult");
      this.url += this.jobID;
      console.log(this.url);
    },
    iframeHeightBypostmessage(e) {
      if (e && e.data && e.data.code === "iframeheight") {
        this.iframeHeight = e.data.text + "px";
      }
    },
    adjustIframe() {
      this.iframeHeight = document.body.height;
    },
  },
};
</script>

<style scoped></style>